import {
	Pipe,
	PipeTransform,
} from '@angular/core';

@Pipe({
	name: 'commonPassportNumberFormatter',
})
export class CommonPassportNumberFormatterPipe implements PipeTransform {
	transform (data: string): string {
		const clearRe = /[\s_-]/g;
		const formatRe = /(\d{2})(\d{2})(\d{6})/;

		data = data.replace(clearRe, '');
		return data.replace(formatRe, '$1 $2 $3');
	}
}
